/**
 * Auth queries and mutations for Admin Portal.
 * Login and authorize integrate with Proxy → Identity service.
 */

export const loginMutation = `
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      code
      emailVerified
      passwordChangeRequired
    }
  }
`;

export const authorizeQuery = `
  mutation Authorize($input: AuthorizeInput!) {
    authorize(input: $input) {
      code
      authorized
      userId
      role
      companyId
      storeId
      accessToken
      refreshToken
    }
  }
`;

export const logoutMutation = `
  mutation Logout($input: LogoutInput) {
    logout(input: $input) {
      code
    }
  }
`;

export const createSecondarySuperAdminMutation = `
  mutation CreateSecondarySuperAdmin($input: CreateSecondarySuperAdminInput!) {
    createSecondarySuperAdmin(input: $input) {
      code
      user {
        id
        email
        firstName
        lastName
        role
      }
    }
  }
`;

export const listSuperAdminsQuery = `
  query ListSuperAdmins {
    listSuperAdmins {
      code
      users {
        id
        firstName
        lastName
        email
        phone
        profileImage
        role
        status
        emailVerified
        passwordChangeRequired
        companyId
        storeId
      }
    }
  }
`;

export const updateSuperAdminStatusMutation = `
  mutation UpdateSuperAdminStatus($userId: String!, $input: UpdateSuperAdminStatusInput!) {
    updateSuperAdminStatus(userId: $userId, input: $input) {
      code
      user {
        id
        firstName
        lastName
        email
        phone
        profileImage
        role
        status
        emailVerified
        passwordChangeRequired
        companyId
        storeId
      }
    }
  }
`;

export const updateSuperAdminRoleMutation = `
  mutation UpdateSuperAdminRole($userId: String!, $input: UpdateSuperAdminRoleInput!) {
    updateSuperAdminRole(userId: $userId, input: $input) {
      code
      user {
        id
        firstName
        lastName
        email
        phone
        profileImage
        role
        status
        emailVerified
        passwordChangeRequired
        companyId
        storeId
      }
    }
  }
`;
